import {
  React,
  lockr,
  Switch,
  observable,
  withStyles,
  StyledProps,
  withRouter,
  SentryRoute, Suspense, uiConstants, Fragment
} from '@api'
import {withProfiler} from '@sentry/react'
import {synchronizeStores} from '@stores/SynchronizeStores'
import {observer} from 'mobx-react'
import {HelmetProvider, Helmet} from 'react-helmet-async'
import {RouteComponentProps} from 'react-router'
import {ShortUrlRedirector} from './ShortUrlRedirector'
import {nav, SiteStore, globalStores as stores, ui, deployments, mobxDevTool, globalStores, aws} from '@stores'
import * as css from './App.css'
import {PrivateRoute, ConfirmationDialog, DevDeploymentsMenu, CatalogRouting, NotFoundPage, StoresInstanceContext, LoadingIndicator} from '@design-board'
import {Login, LogoutContainer} from '@design-board/components'
import {CustomMobxDevTools} from '@stores/dev'
import {SubscribeUI} from './SubscribeUI'
import {authStore} from '@utils'

interface MyProps extends StyledProps, Partial<RouteComponentProps> {
}

@(withRouter as any)
@observer
export class VIP_MerchBoard_App extends React.Component<MyProps> {
  constructor(props) {
    super(props)
    synchronizeStores(() => {
      nav.updateLocation(props.location, props.match)
      //stores.authStore.checkIsAuthenticated() // Private page will do this itself

      document.addEventListener('click', this.onDocumentClick)
    })
  }

  onDocumentClick = (e: MouseEvent) => {
    const {flexLayout} = stores;

    (flexLayout.tabsByComponent?.catalog ?? []).forEach(c => c.catalogRoot?.catalog?.hideCatalogPopover())
  }

  componentDidMount() {
    //fix for safari mobile > 10.x
    let supportsPassive = false
    try {
      const opts = Object.defineProperty({}, 'passive', {
        get: function () {
          supportsPassive = true
        }
      })
      window.addEventListener('testPassive', null, opts)
      window.removeEventListener('testPassive', null, opts)
    } catch (e) {
    }

    if (supportsPassive) {
      window.addEventListener('touchmove', function () {
      }, {passive: false})
    } else {
      window.addEventListener('touchmove', function () {
      })
    }
  }

  componentDidUpdate(prevProps: Readonly<MyProps>, prevState: Readonly<{}>, snapshot?: any): void {
    const {props} = this
    setTimeout(() => {
      nav.updateLocation(props.location, props.match)
    }, 5)
  }

  render() {
      // Remove these from the provider below to avoid errors when remounting the Dashboard component
      const {flexLayout, ...globalStores} = stores,
      mobxConfig = mobxDevTool?.mobxDevToolConfig,
        {app: {appAttributes, appStyles}, site} = stores
    // trace()
    //
    // console.log(prettyPrint({workspaceTitle, detailsTitle, focused: document.visibilityState}))

    return (
      <StoresInstanceContext.Provider value={stores}>
        <Suspense fallback={null}>
          <HelmetProvider>
            <div className={css.root}
                 id='app-root'
              //data-header-look='082021'
                 {...appAttributes}
              //{...dragDrop.appDataAttributes}
                 style={appStyles}
            >
              <PageHeadTag/>

              <SiteStore />

              {DEBUG && module['hot'] && mobxConfig && nav.queryParams.mobx !== undefined && <CustomMobxDevTools/>}
              {deployments.error && DEBUG && <DevDeploymentsMenu/>}

              {/* Show configuration updated snackbar only if user is logged in and current view is not configurator */}
              {/*{token ? <ConfigurationUpdatedSnackbar/> : null}*/}
              {false && authStore.accessToken && !globalStores.catalog?.settings?.noSubscribe ? <SubscribeUI/> : null}

              {site && (!stores.deployments || stores.deployments.initialized) ?
			   <Fragment>
				   <Switch>
					   <SentryRoute path={['/s/:short']}>
						   <ShortUrlRedirector/>
					   </SentryRoute>

					   <SentryRoute path='/login' exact={false} component={Login}/>
             <SentryRoute component={LogoutContainer} exact={false} path={'/logout'}/>

             {/*{appConfig.vipConfiguratorFeature === 'on' && <PrivateRoute component={Configuration} path={[*/}
                     {/*  '/configuration/season/:season/category1/:category1/category2/:category2',*/}
                     {/*  '/configuration/season/:season/category1/:category1',*/}
                     {/*  '/configuration/season/:season',*/}
                     {/*  '/configuration'*/}
                     {/*]}/>}*/}


                     {/* Combined dashboard route handling */}
					   <SentryRoute path={['/', '/dashboard', '/item-details']}>
						   <CatalogRouting/>
					   </SentryRoute>

					   <SentryRoute path='*'>
						   <NotFoundPage/>
					   </SentryRoute>
				   </Switch>
			   </Fragment>
              : site?.blueprintCssLoaded && <LoadingIndicator />}
            </div>
          </HelmetProvider>
        </Suspense>
      </StoresInstanceContext.Provider>
    )
  }
}

if (false && DEBUG && process.env.NODE_ENV !== 'production') {
  const whyDidYouRender = require('@welldone-software/why-did-you-render')
  whyDidYouRender(React, {
    onlyLogs: true, // only for sandbox logging to look nicer
    titleColor: 'green', // only for sandbox logging to look nicer
    diffNameColor: 'aqua', // only for sandbox logging to look nicer
    trackAllPureComponents: true,
    //trackExtraHooks: [[require('mobx-react'), 'observer']],
    exclude: [/^WithStyles/, /^Blueprint3/, /^EventListener/, /^Typography/]
  })
}

export const AppWithSentryProfiler = withProfiler(VIP_MerchBoard_App)

export const PageHeadTag = observer(function PageHeadTag() {
    const {app: {pageTitle, fonts, fontFaces}, deployments: {deploymentConfig}} = globalStores

    return (<Helmet defer={false}>
        <title>
          {pageTitle}
        </title>
        <style>
          {fontFaces}
	    </style>
      </Helmet>
    )
})


// WEBPACK FOOTER //
// ./src/App.tsx